import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['track']

  show({ params: { index } }) {
    this.trackTarget.scrollTo({ left: index * this.trackTarget.clientWidth, behavior: 'smooth' })
  }
}
